import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue";
const _hoisted_1 = { class: "questionnaires-page" };
const _hoisted_2 = { class: "tab-bar" };
const _hoisted_3 = {
    key: 0,
    class: "page-container"
};
const _hoisted_4 = { class: "item-info" };
const _hoisted_5 = { class: "item-name" };
const _hoisted_6 = { class: "item-meta" };
const _hoisted_7 = {
    key: 0,
    class: "badge quiz"
};
const _hoisted_8 = { class: "detail-section" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { class: "section-header" };
const _hoisted_11 = { class: "header-actions-group" };
const _hoisted_12 = {
    key: 0,
    class: "json-editor-section"
};
const _hoisted_13 = {
    key: 0,
    class: "json-error"
};
const _hoisted_14 = { class: "form-row" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "form-row" };
const _hoisted_18 = { class: "form-group" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = { class: "checkbox-label" };
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "form-row" };
const _hoisted_23 = { class: "form-group" };
const _hoisted_24 = { class: "form-group" };
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = { class: "form-group" };
const _hoisted_28 = { class: "form-row" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = { class: "form-row" };
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = { class: "form-group" };
const _hoisted_34 = { class: "form-group" };
const _hoisted_35 = { class: "form-group" };
const _hoisted_36 = { class: "questions-section" };
const _hoisted_37 = { class: "section-header" };
const _hoisted_38 = ["disabled"];
const _hoisted_39 = {
    key: 0,
    class: "add-question-panel"
};
const _hoisted_40 = { key: 0 };
const _hoisted_41 = { class: "form-group" };
const _hoisted_42 = ["value"];
const _hoisted_43 = { class: "add-question-actions" };
const _hoisted_44 = { key: 1 };
const _hoisted_45 = ["onDragstart", "onDrop"];
const _hoisted_46 = ["onClick"];
const _hoisted_47 = { class: "chevron" };
const _hoisted_48 = { class: "question-item-text" };
const _hoisted_49 = {
    key: 0,
    class: "question-item-body"
};
const _hoisted_50 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_51 = {
    key: 1,
    class: "empty-state-section"
};
const _hoisted_52 = {
    key: 1,
    class: "library-section"
};
const _hoisted_53 = { class: "section-header" };
const _hoisted_54 = { class: "subtitle" };
const _hoisted_55 = { class: "search-box" };
const _hoisted_56 = { key: 1 };
const _hoisted_57 = ["onClick"];
const _hoisted_58 = { class: "chevron" };
const _hoisted_59 = { class: "question-item-text" };
const _hoisted_60 = ["onClick"];
const _hoisted_61 = {
    key: 0,
    class: "question-item-body"
};
const _hoisted_62 = {
    key: 2,
    class: "empty-state"
};
const _hoisted_63 = { class: "usage-question" };
const _hoisted_64 = { key: 0 };
const _hoisted_65 = { class: "item-meta" };
const _hoisted_66 = ["onClick"];
const _hoisted_67 = { key: 1 };
import { ref, computed, watch, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
import QuestionCard from '@/admin/components/QuestionCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuestionnairesPage',
    setup(__props) {
        const admin = useAdmin();
        const tabIndex = ref(0);
        const selectedQuestionnaire = ref(null);
        const addingQuestion = ref(false);
        const creatingNewQuestion = ref(false);
        const creatingLibraryQuestion = ref(false);
        const expandedQuestionId = ref(null);
        const expandedLibraryQuestionId = ref(null);
        const draggedIndex = ref(null);
        const librarySearch = ref('');
        const showJsonEditor = ref(false);
        const jsonEditorContent = ref('');
        const jsonError = ref('');
        const showDeleteQuestionnaireDialog = ref(false);
        const showUsageDialog = ref(false);
        const usageQuestion = ref(null);
        const showToast = ref(false);
        const toastMessage = ref('');
        const toastColour = ref('success');
        const questionnaires = computed(() => admin.adminState.questionnaires);
        const questions = computed(() => admin.adminState.questions);
        const loading = computed(() => admin.adminState.questionsLoading);
        const blankQuestion = computed(() => ({ id: '', text: '', questionType: 0, possibleAnswers: [] }));
        const questionnaireQuestions = computed(() => [...(selectedQuestionnaire.value?.questionnaireQuestions || [])].sort((a, b) => (a.order || 0) - (b.order || 0)));
        const filteredLibraryQuestions = computed(() => {
            if (!librarySearch.value)
                return questions.value;
            const search = librarySearch.value.toLowerCase();
            return questions.value.filter((q) => q.text?.toLowerCase().includes(search) || q.key?.toLowerCase().includes(search));
        });
        const usageQuestionnaires = computed(() => {
            if (!usageQuestion.value)
                return [];
            return questionnaires.value.filter((q) => usesQuestion(q, usageQuestion.value.id));
        });
        function usesQuestion(questionnaire, questionId) {
            return (questionnaire.questionnaireQuestions || []).some((qq) => qq.questionId === questionId);
        }
        function usageCount(questionId) {
            return questionnaires.value.filter((q) => usesQuestion(q, questionId)).length;
        }
        // Keep the selected questionnaire pointed at the freshly loaded copy
        watch(questionnaires, (list) => {
            if (selectedQuestionnaire.value?.id && list) {
                selectedQuestionnaire.value = list.find((q) => q.id === selectedQuestionnaire.value.id) || selectedQuestionnaire.value;
            }
        }, { deep: true });
        function showMessage(message) {
            toastMessage.value = message;
            toastColour.value = 'success';
            showToast.value = true;
        }
        function showError(message) {
            toastMessage.value = message || 'An error occurred';
            toastColour.value = 'error';
            showToast.value = true;
        }
        function reload() {
            admin.getQuestionnaires();
            admin.getQuestions();
            addingQuestion.value = false;
            creatingNewQuestion.value = false;
        }
        function showQuestionnaireTab() {
            tabIndex.value = 0;
            reload();
        }
        function showQuestionTab() {
            tabIndex.value = 1;
            admin.getQuestions();
        }
        function selectQuestionnaire(questionnaire) {
            selectedQuestionnaire.value = questionnaire;
            addingQuestion.value = false;
            creatingNewQuestion.value = false;
            expandedQuestionId.value = null;
            showJsonEditor.value = false;
            jsonEditorContent.value = '';
            jsonError.value = '';
        }
        function toggleJsonEditor() {
            jsonError.value = '';
            if (showJsonEditor.value) {
                const parsed = parseJsonEditor();
                if (!parsed)
                    return;
                selectedQuestionnaire.value = parsed;
                showJsonEditor.value = false;
            }
            else {
                jsonEditorContent.value = JSON.stringify(selectedQuestionnaire.value, null, 2);
                showJsonEditor.value = true;
            }
        }
        function parseJsonEditor() {
            try {
                return JSON.parse(jsonEditorContent.value);
            }
            catch (e) {
                jsonError.value = 'Invalid JSON: ' + e.message;
                return null;
            }
        }
        function newQuestionnaire() {
            selectedQuestionnaire.value = {
                id: '',
                key: '',
                title: '',
                isQuiz: false,
                submittedText: '',
                questionnaireQuestions: []
            };
        }
        function saveQuestionnaire() {
            let questionnaire = selectedQuestionnaire.value;
            if (showJsonEditor.value) {
                const parsed = parseJsonEditor();
                if (!parsed)
                    return;
                jsonError.value = '';
                questionnaire = parsed;
                selectedQuestionnaire.value = parsed;
            }
            if (!questionnaire.id) {
                delete questionnaire.id;
                admin.createQuestionnaire(questionnaire, (created) => {
                    selectedQuestionnaire.value = created;
                    showMessage('Questionnaire created');
                });
            }
            else {
                admin.updateQuestionnaire(questionnaire.id, questionnaire, (updated) => {
                    selectedQuestionnaire.value = updated;
                    showMessage('Questionnaire saved');
                });
            }
            creatingNewQuestion.value = false;
        }
        function confirmDeleteQuestionnaire() {
            admin.deleteQuestionnaire(selectedQuestionnaire.value.id, () => {
                selectedQuestionnaire.value = null;
                showMessage('Questionnaire deleted');
            });
            showDeleteQuestionnaireDialog.value = false;
        }
        function cancelAddQuestion() {
            addingQuestion.value = false;
            creatingNewQuestion.value = false;
        }
        function selectExistingQuestion(event) {
            const questionId = event.target.value;
            if (!questionId || !selectedQuestionnaire.value?.id)
                return;
            admin.addQuestionToQuestionnaire(selectedQuestionnaire.value.id, questionId, () => {
                showMessage('Question added to questionnaire');
                cancelAddQuestion();
                reload();
            }, () => showError('Failed to add question to questionnaire'));
        }
        function onQuestionCreated() {
            cancelAddQuestion();
            reload();
        }
        function onLibraryQuestionCreated() {
            creatingLibraryQuestion.value = false;
            admin.getQuestions();
        }
        function toggleQuestion(questionId) {
            expandedQuestionId.value = expandedQuestionId.value === questionId ? null : questionId;
        }
        function toggleLibraryQuestion(questionId) {
            expandedLibraryQuestionId.value = expandedLibraryQuestionId.value === questionId ? null : questionId;
        }
        function dropQuestion(index) {
            const from = draggedIndex.value;
            if (from === null || from === index)
                return;
            const items = [...questionnaireQuestions.value];
            const [moved] = items.splice(from, 1);
            items.splice(index, 0, moved);
            items.forEach((item, i) => (item.order = i + 1));
            selectedQuestionnaire.value.questionnaireQuestions = items;
            draggedIndex.value = null;
            admin.updateQuestionnaire(selectedQuestionnaire.value.id, selectedQuestionnaire.value, () => {
                showMessage('Question order saved');
            });
        }
        function showUsage(question) {
            usageQuestion.value = question;
            showUsageDialog.value = true;
        }
        function viewQuestionnaireFromUsage(questionnaire) {
            showUsageDialog.value = false;
            tabIndex.value = 0;
            selectQuestionnaire(questionnaire);
        }
        onMounted(() => {
            reload();
        });
        return (_ctx, _cache) => {
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                            class: _normalizeClass(["tab", { active: tabIndex.value === 0 }]),
                            onClick: showQuestionnaireTab
                        }, "Questionnaires", 2),
                        _createElementVNode("button", {
                            class: _normalizeClass(["tab", { active: tabIndex.value === 1 }]),
                            onClick: showQuestionTab
                        }, "Question Library", 2),
                        _createElementVNode("button", {
                            class: "action-btn secondary ml-auto",
                            onClick: reload
                        }, "🔄 Reload")
                    ]),
                    (tabIndex.value === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(AdminListSection, {
                                title: "Questionnaires",
                                items: questionnaires.value,
                                "selected-id": selectedQuestionnaire.value?.id,
                                loading: loading.value,
                                "empty-message": "No questionnaires yet",
                                "search-placeholder": "Search questionnaires...",
                                "search-fields": ['title', 'tags'],
                                "show-new-button": true,
                                "new-button-text": "New Questionnaire",
                                onSelect: selectQuestionnaire,
                                onRefresh: reload,
                                onNew: newQuestionnaire
                            }, {
                                item: _withCtx(({ item }) => [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1),
                                        _createElementVNode("div", _hoisted_6, [
                                            (item.isQuiz)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Quiz"))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(item.questionnaireQuestions ? item.questionnaireQuestions.length : 0) + " questions ", 1)
                                        ])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["items", "selected-id", "loading"]),
                            _createElementVNode("div", _hoisted_8, [
                                (selectedQuestionnaire.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("h2", null, _toDisplayString(selectedQuestionnaire.value.title || 'New questionnaire'), 1),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("button", {
                                                    class: "action-btn secondary",
                                                    onClick: toggleJsonEditor
                                                }, _toDisplayString(showJsonEditor.value ? 'Form View' : 'JSON View'), 1),
                                                _createVNode(AdminHeaderActions, {
                                                    "has-id": !!selectedQuestionnaire.value.id,
                                                    onSave: saveQuestionnaire,
                                                    onDelete: _cache[0] || (_cache[0] = ($event) => (showDeleteQuestionnaireDialog.value = true)),
                                                    onNew: newQuestionnaire
                                                }, null, 8, ["has-id"])
                                            ])
                                        ]),
                                        (showJsonEditor.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((jsonEditorContent).value = $event)),
                                                    class: "json-editor-textarea",
                                                    spellcheck: "false"
                                                }, null, 512), [
                                                    [_vModelText, jsonEditorContent.value]
                                                ]),
                                                (jsonError.value)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(jsonError.value), 1))
                                                    : _createCommentVNode("", true)
                                            ]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("div", _hoisted_15, [
                                                        _cache[32] || (_cache[32] = _createElementVNode("label", null, "Title", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedQuestionnaire.value.title) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "Enter questionnaire title"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.title]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_16, [
                                                        _cache[33] || (_cache[33] = _createElementVNode("label", null, "Key", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedQuestionnaire.value.key) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "Use title with no spaces"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.key]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _cache[34] || (_cache[34] = _createElementVNode("label", null, "Tags", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedQuestionnaire.value.tags) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "Enter tags"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.tags]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_19, [
                                                        _createElementVNode("label", _hoisted_20, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedQuestionnaire.value.isQuiz) = $event)),
                                                                type: "checkbox"
                                                            }, null, 512), [
                                                                [_vModelCheckbox, selectedQuestionnaire.value.isQuiz]
                                                            ]),
                                                            _cache[35] || (_cache[35] = _createTextVNode(" Is quiz "))
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_21, [
                                                    _cache[36] || (_cache[36] = _createElementVNode("label", null, "Description", -1)),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedQuestionnaire.value.description) = $event)),
                                                        rows: "2",
                                                        class: "form-input",
                                                        placeholder: "Enter description"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.description]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _cache[37] || (_cache[37] = _createElementVNode("label", null, "Action button text", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedQuestionnaire.value.actionButtonText) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "e.g. Calculate"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.actionButtonText]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _cache[38] || (_cache[38] = _createElementVNode("label", null, "Image path", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedQuestionnaire.value.imgPath) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "e.g. Inbest.svg"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.imgPath]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Summary image path", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((selectedQuestionnaire.value.summaryImgPath) = $event)),
                                                            type: "text",
                                                            class: "form-input"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.summaryImgPath]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_26, [
                                                    _cache[40] || (_cache[40] = _createElementVNode("label", null, "Further information", -1)),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedQuestionnaire.value.furtherInformation) = $event)),
                                                        rows: "2",
                                                        class: "form-input"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.furtherInformation]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_27, [
                                                    _cache[41] || (_cache[41] = _createElementVNode("label", null, "Further information URL", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedQuestionnaire.value.furtherInformationUrl) = $event)),
                                                        type: "text",
                                                        class: "form-input"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.furtherInformationUrl]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createElementVNode("div", _hoisted_29, [
                                                        _cache[42] || (_cache[42] = _createElementVNode("label", null, "Start date/time", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedQuestionnaire.value.startDateTime) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "YYYY-MM-DDTHH:mm:ss"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.startDateTime]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_30, [
                                                        _cache[43] || (_cache[43] = _createElementVNode("label", null, "End date/time", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((selectedQuestionnaire.value.endDateTime) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "YYYY-MM-DDTHH:mm:ss"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.endDateTime]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("div", _hoisted_32, [
                                                        _cache[44] || (_cache[44] = _createElementVNode("label", null, "Hex colour 1", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedQuestionnaire.value.hexColor1) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "#RRGGBB"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.hexColor1]
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _cache[45] || (_cache[45] = _createElementVNode("label", null, "Hex colour 2", -1)),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((selectedQuestionnaire.value.hexColor2) = $event)),
                                                            type: "text",
                                                            class: "form-input",
                                                            placeholder: "#RRGGBB"
                                                        }, null, 512), [
                                                            [_vModelText, selectedQuestionnaire.value.hexColor2]
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_34, [
                                                    _cache[46] || (_cache[46] = _createElementVNode("label", null, "Submitted text", -1)),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((selectedQuestionnaire.value.submittedText) = $event)),
                                                        rows: "3",
                                                        class: "form-input",
                                                        placeholder: "Use %SCORE% for quiz score 'x out of y'"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.submittedText]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_35, [
                                                    _cache[47] || (_cache[47] = _createElementVNode("label", null, "Return URL", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((selectedQuestionnaire.value.returnUrl) = $event)),
                                                        type: "text",
                                                        class: "form-input",
                                                        placeholder: "Enter URL to redirect to after submission"
                                                    }, null, 512), [
                                                        [_vModelText, selectedQuestionnaire.value.returnUrl]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                    _createElementVNode("div", _hoisted_37, [
                                                        _createElementVNode("h2", null, "Questions (" + _toDisplayString(questionnaireQuestions.value.length) + ")", 1),
                                                        (!addingQuestion.value)
                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                key: 0,
                                                                class: "action-btn secondary",
                                                                disabled: !selectedQuestionnaire.value.id,
                                                                onClick: _cache[18] || (_cache[18] = ($event) => (addingQuestion.value = true))
                                                            }, " ➕ Add Question ", 8, _hoisted_38))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    (addingQuestion.value)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                            (!creatingNewQuestion.value)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                    _createElementVNode("div", _hoisted_41, [
                                                                        _cache[49] || (_cache[49] = _createElementVNode("label", null, "Select an existing question", -1)),
                                                                        _createElementVNode("select", {
                                                                            class: "form-input",
                                                                            onChange: _cache[19] || (_cache[19] = ($event) => (selectExistingQuestion($event)))
                                                                        }, [
                                                                            _cache[48] || (_cache[48] = _createElementVNode("option", { value: "" }, "Choose a question...", -1)),
                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (q) => {
                                                                                return (_openBlock(), _createElementBlock("option", {
                                                                                    key: q.id,
                                                                                    value: q.id
                                                                                }, _toDisplayString(q.text), 9, _hoisted_42));
                                                                            }), 128))
                                                                        ], 32)
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_43, [
                                                                        _createElementVNode("button", {
                                                                            class: "action-btn primary",
                                                                            onClick: _cache[20] || (_cache[20] = ($event) => (creatingNewQuestion.value = true))
                                                                        }, "➕ Create New Question"),
                                                                        _createElementVNode("button", {
                                                                            class: "action-btn secondary",
                                                                            onClick: cancelAddQuestion
                                                                        }, "Cancel")
                                                                    ])
                                                                ]))
                                                                : (_openBlock(), _createBlock(QuestionCard, {
                                                                    key: 1,
                                                                    question: blankQuestion.value,
                                                                    "questionnaire-id": selectedQuestionnaire.value.id,
                                                                    "init-edit-mode": true,
                                                                    "is-new-question": true,
                                                                    onCreated: onQuestionCreated,
                                                                    onCancelNew: cancelAddQuestion,
                                                                    onMessage: showMessage,
                                                                    onError: showError
                                                                }, null, 8, ["question", "questionnaire-id"]))
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (questionnaireQuestions.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionnaireQuestions.value, (qq, index) => {
                                                                return (_openBlock(), _createElementBlock("div", {
                                                                    key: qq.questionId,
                                                                    class: "question-item",
                                                                    draggable: "true",
                                                                    onDragstart: ($event) => (draggedIndex.value = index),
                                                                    onDragover: _cache[21] || (_cache[21] = _withModifiers(() => { }, ["prevent"])),
                                                                    onDragenter: _cache[22] || (_cache[22] = _withModifiers(() => { }, ["prevent"])),
                                                                    onDrop: ($event) => (dropQuestion(index)),
                                                                    onDragend: _cache[23] || (_cache[23] = ($event) => (draggedIndex.value = null))
                                                                }, [
                                                                    _createElementVNode("div", {
                                                                        class: "question-item-header",
                                                                        onClick: ($event) => (toggleQuestion(qq.questionId))
                                                                    }, [
                                                                        _cache[50] || (_cache[50] = _createElementVNode("span", { class: "drag-handle" }, "⋮⋮", -1)),
                                                                        _createElementVNode("span", _hoisted_47, _toDisplayString(expandedQuestionId.value === qq.questionId ? '▾' : '▸'), 1),
                                                                        _createElementVNode("span", _hoisted_48, _toDisplayString(qq.question.text), 1)
                                                                    ], 8, _hoisted_46),
                                                                    (expandedQuestionId.value === qq.questionId)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                                            _createVNode(QuestionCard, {
                                                                                question: qq.question,
                                                                                "questionnaire-id": selectedQuestionnaire.value.id,
                                                                                onChange: reload,
                                                                                onMessage: showMessage,
                                                                                onError: showError
                                                                            }, null, 8, ["question", "questionnaire-id"])
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ], 40, _hoisted_45));
                                                            }), 128))
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_50, "No questions added yet."))
                                                ])
                                            ], 64))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[51] || (_cache[51] = [
                                        _createElementVNode("p", null, "Select a questionnaire to view its details", -1)
                                    ])))
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", null, [
                                    _cache[52] || (_cache[52] = _createElementVNode("h2", null, "Question Library", -1)),
                                    _createElementVNode("p", _hoisted_54, _toDisplayString(filteredLibraryQuestions.value.length) + " of " + _toDisplayString(questions.value.length) + " questions", 1)
                                ]),
                                _createElementVNode("button", {
                                    class: "action-btn primary",
                                    onClick: _cache[24] || (_cache[24] = ($event) => (creatingLibraryQuestion.value = true))
                                }, "➕ Create New Question")
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((librarySearch).value = $event)),
                                    type: "text",
                                    class: "form-input",
                                    placeholder: "Search questions by text..."
                                }, null, 512), [
                                    [_vModelText, librarySearch.value]
                                ])
                            ]),
                            (creatingLibraryQuestion.value)
                                ? (_openBlock(), _createBlock(QuestionCard, {
                                    key: 0,
                                    question: blankQuestion.value,
                                    "init-edit-mode": true,
                                    "is-new-question": true,
                                    onCreated: onLibraryQuestionCreated,
                                    onCancelNew: _cache[26] || (_cache[26] = ($event) => (creatingLibraryQuestion.value = false)),
                                    onMessage: showMessage,
                                    onError: showError
                                }, null, 8, ["question"]))
                                : _createCommentVNode("", true),
                            (filteredLibraryQuestions.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLibraryQuestions.value, (q) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: q.id,
                                            class: "question-item"
                                        }, [
                                            _createElementVNode("div", {
                                                class: "question-item-header",
                                                onClick: ($event) => (toggleLibraryQuestion(q.id))
                                            }, [
                                                _createElementVNode("span", _hoisted_58, _toDisplayString(expandedLibraryQuestionId.value === q.id ? '▾' : '▸'), 1),
                                                _createElementVNode("span", _hoisted_59, _toDisplayString(q.text), 1),
                                                _createElementVNode("button", {
                                                    class: "action-btn secondary usage-btn",
                                                    onClick: _withModifiers(($event) => (showUsage(q)), ["stop"])
                                                }, " Usage (" + _toDisplayString(usageCount(q.id)) + ") ", 9, _hoisted_60)
                                            ], 8, _hoisted_57),
                                            (expandedLibraryQuestionId.value === q.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                                    _createVNode(QuestionCard, {
                                                        question: q,
                                                        onChange: reload,
                                                        onMessage: showMessage,
                                                        onError: showError
                                                    }, null, 8, ["question"])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_62, "No questions in the library yet."))
                        ]))
                ]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteQuestionnaireDialog.value,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((showDeleteQuestionnaireDialog).value = $event)),
                    title: "Delete Questionnaire",
                    "max-width": "300px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "Are you sure you want to delete \"" + _toDisplayString(selectedQuestionnaire.value?.title) + "\"?", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteQuestionnaire,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[27] || (_cache[27] = ($event) => (showDeleteQuestionnaireDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showUsageDialog.value,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((showUsageDialog).value = $event)),
                    title: "Questionnaires Using This Question",
                    "max-width": "500px"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", _hoisted_63, _toDisplayString(usageQuestion.value?.text), 1),
                        (usageQuestionnaires.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usageQuestionnaires.value, (q) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: q.id,
                                        class: "usage-item"
                                    }, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, _toDisplayString(q.title), 1),
                                            _createElementVNode("div", _hoisted_65, _toDisplayString(q.isQuiz ? 'Quiz' : 'Questionnaire'), 1)
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: ($event) => (viewQuestionnaireFromUsage(q))
                                        }, "View", 8, _hoisted_66)
                                    ]));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_67, "This question is not used in any questionnaires yet."))
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Close",
                            outline: true,
                            onClick: _cache[29] || (_cache[29] = ($event) => (showUsageDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showToast.value,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((showToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: toastColour.value
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(toastMessage.value), 1)
                    ]),
                    _: 1
                }, 8, ["modelValue", "color"])
            ], 64));
        };
    }
});
